import "./status.scss";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export const Status = () => {
  const { id } = useParams();
  const [data, setData] = useState();

  useEffect(() => {
    const route = id.slice(id.length - 1) === "r" ? "reports" : "searches";
    fetch(
      `https://nameless-ridge-78695.herokuapp.com/api/${route}/${id.slice(
        0,
        -1
      )}`
    )
      .then((res) => res.json())
      .then((data) => {
        setData(data);
      });
  }, []);

  if (!data) return <div>loading...</div>;

  return (
    <div className="status-container">
      <div className="top">
        <h3>الحالة</h3>
        <p
          className="status"
          style={{
            background:
              data.status === "في انتظار تدخل الأدمن"
                ? "red"
                : data.status === "تم التوصل إلى نتيجة"
                ? "green"
                : "lightgray",
          }}
        >
          {data.status}
        </p>
      </div>

      <div className="bottom">
        <h4>ملخص الحالة</h4>

        <div className="data-container">
          <div className="data-div">
            <p>صورة الطفل</p>
            <img
              src={`https://firebasestorage.googleapis.com/v0/b/thefirstapp-cdb09.appspot.com/o/files%2Fdata%2Fuser%2F0%2Fcom.example.newapp%2Fcache%2Ffile_picker%2F${data.img}?alt=media`}
              alt=""
            />
          </div>
          {data.name && (
            <div className="data-div">
              <p>اسم الطفل</p>
              <p>{data.name}</p>
            </div>
          )}
          {data.description && (
            <div className="data-div">
              <p>وصف الطفل</p>
              <p>{data.description}</p>
            </div>
          )}
          {data.address && (
            <div className="data-div">
              <p>عنوان الطفل</p>
              <p>{data.address}</p>
            </div>
          )}
          {data.birthday && (
            <div className="data-div">
              <p>تاريخ ميلادالطفل</p>
              <p>{data.birthday}</p>
            </div>
          )}
          {data.age && (
            <div className="data-div">
              <p>سن الطفل</p>
              <p>{data.age}</p>
            </div>
          )}
          {data.lost_location && (
            <div className="data-div">
              <p>مكان ضياع الطفل</p>
              <p>{data.lost_location}</p>
            </div>
          )}
          {data.lost_date && (
            <div className="data-div">
              <p>تاريخ ضياع الطفل</p>
              <p>{data.lost_date}</p>
            </div>
          )}
          {data.danger_state ||
            (data.feeling && (
              <div className="data-div">
                <p>درجة الخطورة</p>
                <p>{data.danger_state || data.feeling}</p>
              </div>
            ))}
          {data.nationality && (
            <div className="data-div">
              <p>الجنسية</p>
              <p>{data.nationality}</p>
            </div>
          )}
          {data.national_id && (
            <div className="data-div">
              <p>الرقم القومي للمستخدم</p>
              <p>{data.national_id}</p>
            </div>
          )}
          {data.family_relation && (
            <div className="data-div">
              <p>القرابة العائلية</p>
              <p>{data.family_relation}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
